import type { IconProps } from './types';
import './icons.css';

export default function Calendar({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      width={width || 24}
      height={height || 24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={`icon icon-calendar ${className || ''}`}
      fill="none"
    >
      <path
        stroke="currentColor"
        d="M20 5v16H4V5m16 0H4m16 0v4H4V5m3-3v3m10-3v3"
      />
    </svg>
  );
}
